import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	signIn: {
		defaultMessage: 'Sign in',
		id: 'atlassian-navigation.sign-in.sign-in',
		description: 'Sign in',
	},
});
